import { defaultApiConfig } from '@callbridge/ui';

const serverUrl = import.meta.env.VITE_SERVER_URL ?? '';

// When VITE_SERVER_URL is set (FB / itch.io / Poki / CrazyGames builds), all
// API calls must use the absolute server URL because relative /api paths
// resolve against the current host (the platform's CDN, not bridgeplay.online).
export const API_BASE = serverUrl ? `${serverUrl}/api` : defaultApiConfig.baseUrl;
